<template>
    <div    class="">
        <!-- Modal for viewing the profile template -->
        <slide-over-panel     v-if="deviceProfile !== null"
                        v-model:show="$data._show"
                        @update:show="updateShow($data._show)">
            <template   #title>
                <div    class="flex items-center">
                    <span>Profile Template Information for {{ deviceProfile.title }}</span>
                    <div    class="ml-2">
                        <small-colored-check    v-model="deviceProfile.active"
                                                @update:modelValue="updateActive"
                                                :togglable="permissions.can('update_device_profile_template') && canToggleActive"
                        ></small-colored-check>
                    </div>
                </div>
            </template>

            <template   #content>
                <div>
                    <green-button   v-if="deviceProfile.active"
                                    @click="duplicateProfile"
                    >
                        <div    class="inline-flex">
                            <span>Duplicate Profile</span>
                        </div>
                    </green-button>
                </div>

                <div    class="mt-4">
                    <span   class="text-lg text-gray-900 text-left font-semibold">Company</span>
                    <p  class="mt-2 text-sm text-gray-700 text-left font-normal">
                        {{ deviceProfile.company.name }}
                    </p>
                </div>

                <div    class="flex flex-col items-start mt-4">
                    <label   for="device_profile_description"
                             class="text-lg text-gray-900 text-left font-semibold">Description</label>
                    <textarea   id="device_profile_description"
                                class="mt-2 p-1 text-sm text-gray-700 text-left font-normal w-full rounded border border-gray-200 bg-white"
                                :value="deviceProfile.description"
                                disabled
                    >
                    </textarea>
                </div>

                <div v-if="deviceProfile.networkQuestionnaireId"   class="mt-4 pb-4 border-b border-gray-200">
                    <span   class="text-lg text-gray-900 text-left font-semibold">Network Questionnaire ID</span>
                    <p  class="mt-2 text-sm text-gray-700 text-left font-normal">
                        <a :href="'https://qa.sonicumonitoring.com/nova/resources/network-questionnaires/' + deviceProfile.networkQuestionnaireId">{{ deviceProfile.networkQuestionnaireId }}</a>
                    </p>
                </div>

                <div    class="mt-4 pb-4 border-b border-gray-200">
                    <span   class="text-lg text-gray-900 text-left font-semibold">Target Device Type</span>
                    <p  class="mt-2 text-sm text-gray-700 text-left font-normal">
                        {{ deviceProfile.targetDeviceType }}
                    </p>
                </div>

                <!-- Device Characteristics -->
                <div>
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Characteristic
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Value
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr     v-for="(characteristic, index) in deviceProfile.characteristics"
                                                :class="[index % 2 === 1 ? 'bg-white' : 'bg-gray-50']">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {{ characteristic.displayName }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ characteristic.prettyValue }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </slide-over-panel>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SlideOverPanel from '@/components/elements/SlideOverPanel'
import GreenButton from '@/components/elements/green-button'
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";

export default {
    name: "DeviceProfileTemplateShow",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {SmallColoredCheck, SlideOverPanel, GreenButton},
    props: {
        show: Boolean,
        deviceProfile: Object,
        canToggleActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            _show: this.show,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        updateShow(show) {
            this.$data._show = show
            this.$emit('update:show', this.$data._show)
        },
        duplicateProfile() {
            sessionStorage.setItem('duplicateProfile', this.deviceProfile.id)
            window.location = this.company.buildCompanyRoute('device-profile-template/create')
        },
        updateActive() {
            axios.put(this.company.buildCompanyApiInternalRoute(`internal-device-profile-template/${this.deviceProfile.id}`, this.deviceProfile.company.id), {
                active: this.deviceProfile.active
            }).then(response => {
                this.deviceProfile.active = response.data.active
            }).catch(error => {
                console.log('Error Toggling the device profile template to be ' + (this.deviceProfile.active) ? 'inactive' : 'active')
            }).then(() => {

            })
        }
    },
    computed: {

    },
    watch: {
        show() {
            this.$data._show = this.show
        }
    },
}

</script>

<style scoped>

</style>